import { Divider, Tab, Tabs } from "@material-ui/core";
import React, { Suspense } from "react";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import Spinner from "./Spinner";

export interface NavigationTabDefinition {
  id: string;
  label: string;
  page: JSX.Element;
  disabled?: boolean;
}

export default function NavigationTabs(props: {
  basePath: string;
  tabs: NavigationTabDefinition[];
  currentTabID: string | undefined;
}) {
  if (!props.tabs) {
    return null;
  }
  const basePath = props.basePath.endsWith("/")
    ? props.basePath
    : props.basePath + "/";

  return (
    <>
      <Tabs value={props.currentTabID ?? props.tabs[0].id} centered>
        {props.tabs.map((tab) => (
          <Tab
            label={tab.label}
            value={tab.id}
            component={Link}
            to={basePath + tab.id}
            key={tab.id}
            disabled={tab.disabled}
          />
        ))}
      </Tabs>
      <Divider />
      <div style={{ paddingTop: "20px" }}>
        <Suspense fallback={<Spinner />}>
          <Switch>
            {props.tabs.map((tab) => (
              <Route path={basePath + tab.id} key={tab.id}>
                {tab.page}
              </Route>
            ))}
            <Route path="*">
              <Redirect to={basePath + props.tabs[0].id} />
            </Route>
          </Switch>
        </Suspense>
      </div>
    </>
  );
}
